import { Route, Routes } from "react-router-dom";
import Homepage from "./javascript_files/Homepage/Homepage";
import CategoryMaster from "./javascript_files/Master/CategoryMaster";
import Overview from "./javascript_files/Homepage/Overview";
import SubCategoryMaster from "./javascript_files/Master/SubCategoryMaster";
import HSNMaster from "./javascript_files/Master/HSNMaster";
import CurrencyMaster from "./javascript_files/Master/CurrencyMaster";
import UnitMaster from "./javascript_files/Master/UnitMaster";
import PackingMaster from "./javascript_files/Master/PackingMaster";
import GSTMaster from "./javascript_files/Master/GSTMaster";
import PartsMaster from "./javascript_files/Master/PartsMaster";
import BoilerMaster from "./javascript_files/Master/BoilerMaster";
import BoilerSeriesMaster from "./javascript_files/Master/BoilerSeriesMaster";
import BoilerSeriesPartsMappingMaster from "./javascript_files/Master/BoilerSeriesPartsMappingMaster";
import CourierMaster from "./javascript_files/Master/CourierMaster";
import TechnicianMaster from "./javascript_files/Master/TechnicianMaster";
import CustomerMaster from "./javascript_files/Master/CustomerMaster";
import CustomerPricingMaster from "./javascript_files/Master/CustomerPricingMaster";
import QuotationMaster from "./javascript_files/Master/QuotationMaster.js";
import Signin from "./javascript_files/Signin/Signin";
import Login from "./javascript_files/Signin/Login";
import Register from "./javascript_files/Signin/Register";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Users from "./javascript_files/Admin/Users.js";
import RoleManagement from "./javascript_files/Admin/RoleManagement.js";
import { useEffect, useState } from "react";
import Enquiries from "./javascript_files/Enquiry/Enquiries.js";
import Step1Ticket from "./javascript_files/Ticket/Step1Ticket.js";
import CheckinSteps from "./javascript_files/Enquiry/CheckinSteps.js";
import Step2Ticket from "./javascript_files/Ticket/Step2Ticket.js";
import Step3Ticket from "./javascript_files/Ticket/Step3Ticket.js";
import Tickets from "./javascript_files/Ticket/Tickets.js";
import Quotations from "./javascript_files/Quotation/Quotations.js";
import Step4Ticket from "./javascript_files/Ticket/Step4Ticket.js";
import Step5Ticket from "./javascript_files/Ticket/Step5Ticket.js";
import Orders from "./javascript_files/Orders/Orders.js";
import CustomerEnquiryForm from "./javascript_files/Customer/CustomerEnquiryForm.js";
import CustomerEnquiries from "./javascript_files/Customer/CustomerEnquiries.js";
import Reports from "./javascript_files/Reports/Reports.js";
import ServiceReports from "./javascript_files/Technician/Reports.js";
import Customers from "./javascript_files/Customer/Customers.js";
import QuotationPopup from "./javascript_files/Quotation/QuotationPopup.js";
import DetailReport from "./javascript_files/Reports/DetailReport.js";
import Invoices from "./javascript_files/Invoices/Invoices.js";
import UploadDownload from "./javascript_files/UploadDownload/UploadDownload.js";
import AuditLog from "./javascript_files/Admin/AuditLog.js";
import { ToastContainer } from "react-toastify";
import Vouchers from "./javascript_files/Technician/Vouchers.js";
import Locations from "./javascript_files/Technician/Locations.js";
import SiteContactDetails from "./javascript_files/Technician/SiteContactDetails.js";
import ViewLocation from "./javascript_files/Technician/ViewLocation.js";
import KilometreRate from "./javascript_files/Master/KilometreRate.js";
import Technicians from "./javascript_files/Technician/Technicians.js";
import ServiceReportMaster from "./javascript_files/Master/ServiceReportMaster.js";
import ServiceReportMapping from "./javascript_files/Master/ServiceReportMapping.js";
import { onMessage } from "firebase/messaging";
import { messaging } from "./firebase";

function App() {
  const [isloggedin, setisloggedin] = useState(false);
  const [isloggedout, setisloggedout] = useState(false);
  const [catchStep, setCatchStep] = useState("");
  const [enquiryId, setEnquiryId] = useState("");
  const [ticketId, setTicketId] = useState("");
  const [quotationId, setQuotationId] = useState("");

  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      const data = payload.data || {};

      if (Notification.permission === "granted") {
        new Notification(data.senderName || "New Message", {
          body: data.body || "You have a new message",

          icon: "/images/Image 905.jpg",

          data: data,
        });
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <>
      <ToastContainer />
      <Routes>
        <Route
          path="/"
          element={
            <Signin isloggedout={isloggedout} setisloggedout={setisloggedout} />
          }
        >
          <Route
            path="/login"
            element={<Login setisloggedin={setisloggedin} />}
          />
        </Route>
        <Route
          path="/dashboard"
          element={
            <Homepage
              isloggedin={isloggedin}
              setisloggedin={setisloggedin}
              setisloggedout={setisloggedout}
            />
          }
        >
          <Route path="/dashboard" element={<Overview />} />
          <Route path="audit-log" Component={AuditLog} />
          <Route path="master/category-master" element={<CategoryMaster />} />
          <Route
            path="master/sub-category-master"
            element={<SubCategoryMaster />}
          />
          <Route path="master/hsn-master" element={<HSNMaster />} />
          <Route path="master/currency-master" element={<CurrencyMaster />} />
          <Route path="master/unit-master" element={<UnitMaster />} />
          <Route path="master/packing-master" element={<PackingMaster />} />
          <Route path="master/gst-master" element={<GSTMaster />} />
          <Route path="master/parts-master" element={<PartsMaster />} />
          <Route path="master/boiler-master" element={<BoilerMaster />} />
          <Route
            path="master/service-report-master"
            element={<ServiceReportMaster />}
          />
          <Route
            path="master/service-report-mapping"
            element={<ServiceReportMapping />}
          />
          <Route
            path="master/boiler-series-master"
            element={<BoilerSeriesMaster />}
          />
          <Route
            path="master/boiler-series-parts-mapping-master"
            element={<BoilerSeriesPartsMappingMaster />}
          />
          <Route path="master/courier-master" element={<CourierMaster />} />
          <Route
            path="master/technician-master"
            element={<TechnicianMaster />}
          />
          <Route path="master/customer-master" element={<CustomerMaster />} />
          <Route
            path="master/customer-pricing-master"
            element={<CustomerPricingMaster />}
          />
          <Route path="master/quotation-master" element={<QuotationMaster />} />
          <Route path="master/kilometer-rate" element={<KilometreRate />} />
          <Route path="admin/users" element={<Users />} />
          <Route path="admin/roles" element={<RoleManagement />} />
          <Route path="customer-enquiries" Component={CustomerEnquiries} />
          <Route path="detail/report" Component={DetailReport} />
          <Route
            path="customers"
            element={
              <Customers
                setEnquiryId={setEnquiryId}
                setQuotationId={setQuotationId}
                setTicketId={setTicketId}
              />
            }
          />
          <Route path="reports" Component={Reports} />
          <Route
            path="enquiries"
            element={<Enquiries setEnquiryId={setEnquiryId} />}
          />
          <Route
            path="tickets"
            element={
              <Tickets
                setTicketId={setTicketId}
                setEnquiryId={setEnquiryId}
                ticketId={ticketId}
              />
            }
          />
          <Route
            path="invoices"
            element={<Invoices setEnquiryId={setEnquiryId} />}
          />
          <Route
            path="quotations"
            element={
              <Quotations
                setQuotationId={setQuotationId}
                setTicketId={setTicketId}
                setEnquiryId={setEnquiryId}
                quotationId={quotationId}
              />
            }
          />
          <Route
            path="quotations/edit/:quotationId"
            Component={QuotationPopup}
          />
          <Route path="orders" Component={Orders} />
          <Route
            path="checkin/steps"
            element={<CheckinSteps catchStep={catchStep} />}
          >
            <Route
              path="step1"
              element={
                <Step1Ticket
                  setCatchStep={setCatchStep}
                  enquiryId={enquiryId}
                  setTicketId={setTicketId}
                  ticketId={ticketId}
                />
              }
            />
            <Route
              path="step2"
              element={
                <Step2Ticket
                  setCatchStep={setCatchStep}
                  enquiryId={enquiryId}
                  ticketId={ticketId}
                  setQuotationId={setQuotationId}
                />
              }
            />
            <Route
              path="step3"
              element={
                <Step3Ticket
                  setCatchStep={setCatchStep}
                  enquiryId={enquiryId}
                  quotationId={quotationId}
                />
              }
            />
            <Route
              path="step4/:quotationId"
              element={
                <Step4Ticket
                  setCatchStep={setCatchStep}
                  setEnquiryId={setEnquiryId}
                />
              }
            />
            <Route
              path="step5/:quotationId"
              element={
                <Step5Ticket
                  setCatchStep={setCatchStep}
                  enquiryId={enquiryId}
                />
              }
            />
          </Route>
          <Route path="upload-download" Component={UploadDownload} />
          <Route path="technician/vouchers" Component={Vouchers} />
          <Route path="technician/locations" Component={Locations} />
          <Route path="technician/reports" Component={ServiceReports} />
          <Route path="technician/sitecontact" Component={SiteContactDetails} />
          <Route path="technician/view-location/:id" Component={ViewLocation} />
          <Route path="technician/technicians" Component={Technicians} />
        </Route>
        <Route path="/customer-enquiry-form" Component={CustomerEnquiryForm} />
      </Routes>
    </>
  );
}

export default App;
